import { clientActionTypes } from './client.types';

const INITIAL_STATE = {
    clients: [],
    currentClient: {},
    currentClientValidated: []
};

const clientReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case clientActionTypes.SET_NEW_CLIENT:
            var clients = state.clients;
            clients.push(action.payload);
            return {
                ...state,
                clients: clients
            };

        case clientActionTypes.SET_CURRENT_CLIENT:
            return {
                ...state,
                currentClient: action.payload
            };

        case clientActionTypes.SET_CURRENT_CLIENT_VALIDATED:
            return {
                ...state,
                currentClientValidated: action.payload
            };

        case clientActionTypes.SET_CLIENTS:
            return {
                ...state,
                clients: action.payload
            };

        default:
            return state;
    }
};

export default clientReducer;